import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AsyncComponent from './asyncComponent';
import PrivateRoute from '../Utils/PrivateRoute';
import Dashboard from '../Admin/Home';

export default function Router() {
  return (
    <div>
      <Switch>
        <PrivateRoute path="/dashboard" component={Dashboard}/>
        
        <Route exact path="/" render={() => (
          <AsyncComponent
            importComponent={() => import('../Admin/Login')}
          />
        )} />
        <Route exact path="/home" render={() => (
          <AsyncComponent
            importComponent={() => import('../Admin/Login')}
          />
        )} />
        <Route exact path="/login" render={() => (
          <AsyncComponent
            importComponent={() => import('../Admin/Login')}
          />
        )} />
        <Route exact path="*" render={() => (
          <AsyncComponent
            importComponent={() => import('../NotFound')}
          />
        )} />
      </Switch>
    </div>
  );
}